module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [(!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Number",
            "field": "number",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e(), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Contract/Student",
            "field": "contract_id",
            "optionListApiUrl": '/contracts/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), ((props.rec.scholarship_payment_type_id === 2)) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice/Credit Note",
            "field": "linked_invoice_id",
            "optionListApiUrl": '/invoices_credit_notes/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Payment Type",
            "field": "scholarship_payment_type_id",
            "optionListApiUrl": '/scholarship_payment_types/choice/',
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Period",
            "field": "period",
            "rec": props.rec,
            "isReadOnly": !_vm.isNew,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount",
            "field": "amount",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Description",
            "field": "description",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly || (_vm.isEdit && !_vm.isPlanned),
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Planned Date",
            "field": "planned_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        }), _vm._v(" "), (!_vm.isNew) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Payment Date",
            "field": "payment_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), ((props.rec.scholarship_payment_type_id === 5)) ? _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "University",
            "field": "university_id",
            "optionListApiUrl": '/universities/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }) : _vm._e()], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Exported",
            "field": "exported_timestamp",
            "field2": "exported_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()]) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [(_vm.privUser && _vm.isNumbered) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (_vm.isNumbered) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.resetExport(props.rec)
            }
          }
        }, [_vm._v("Reset Export")]) : _vm._e()], 2) : _vm._e()]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29139b46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ScholarshipPayment/Detail.vue
// module id = 697
// module chunks = 1